import type { Degree, Radian } from "../types/Units"
import { PI } from "./Math"

/**
 * Converts degrees to radians
 */
export const ToRadians = (degrees: Degree): Radian =>
  (degrees * (PI / 180)) as Radian
